import type { ToastPortalProps } from './types'

import { Toast as BaseToast } from '@base-ui/react/toast'

export function ToastPortal(props: ToastPortalProps) {
  return <BaseToast.Portal {...props} />
}
ToastPortal.displayName = 'Toast.Portal'
